import { config, zSpaceConfig } from '../config';
import { Object3D, Vector3 } from 'three';
import { ParentEvent, ResourcesManager, ScenarioProcessor, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import TasksProgress from '../components/TasksProgress';
import TaskScreen from '../components/TaskScreen';
import WelcomeScreen from '../components/WelcomeScreen';
import LobbyScreen from '../components/LobbyScreen';
import SerologicalPipetteModule from './SerologicalModules/SerologicalPipetteModule';
import SerologicalPipetteHolderModule from './SerologicalModules/SerologicalPipetteHolderModule';
import SerologicalTestTubeHolderModule from './SerologicalModules/SerologicalTestTubeHolderModule';
import SerologicalJarModule from './SerologicalModules/SerologicalJarModule';
import { MaterialImprovement } from '../utils/MaterialImprovement';
export default class SerologicalLevel extends ViewerModule {
    constructor(levelNumber, title, lobby) {
        super();
        this.lobby = lobby;
        this.__inited = false;
        this.cameraPositionVR = new Vector3(0, -15.75, -9.4881);
        this.cameraPosition = new Vector3(0, -13.5982, -9.4881);
        this.cameraTargetNormal = new Vector3(0, -13.6, -9.498);
        this.wrapScreenPosition = new Vector3(-4, 1.54, -5.15);
        this.levelFinished = false;
        this._interaction = false;
        window['SerologicalLevel'] = this;
        this.viewerConf = config;
        this.pointerController = Viewer.pointerController;
        this.pointerController.uiObject.name = 'pointerController';
        this.uiObject.name = 'Serological LEVEL';
        this.table = ResourcesManager.getModel('serological_table').clone();
        this.table.name = 'TABLE';
        this.zSpacePositions = zSpaceConfig.serological;
        this.table.position.set(0, -7, 0);
        this.addObject(this.table);
        this.initInstruments();
        this.addUI();
        this.addLobbyUI(levelNumber, title);
        this.initScenario();
    }
    get interaction() {
        return this._interaction;
    }
    set interaction(value) {
        this._interaction = value;
        console.log('Serological LEVEL INTERACTION = ', this._interaction);
    }
    initInstruments() {
        this.instrumentsPositions = {
            pipetteHolder: new Vector3(-2.67, 4.77, -.70),
            pipette: new Vector3(0, 0, 0),
            testTubeHolder: new Vector3(2.25, 3.57, -.41),
            jar: new Vector3(0, 4.36, 3.5),
        };
        this.instruments = {
            pipetteHolder: new SerologicalPipetteHolderModule(this),
            pipette: new SerologicalPipetteModule(this),
            testTubeHolder: new SerologicalTestTubeHolderModule(this),
            jar: new SerologicalJarModule(this),
        };
        for (let instrumentsKey in this.instruments) {
            if (!this.instruments.hasOwnProperty(instrumentsKey))
                continue;
            this.addObject(this.instruments[instrumentsKey], null, this.table);
            // this.table.add(this.instruments[instrumentsKey].uiObject);
            this.instruments[instrumentsKey].uiObject.position.copy(this.instrumentsPositions[instrumentsKey]);
        }
        // this.instruments.pipette.addToHolder();
    }
    addUI() {
        this.addObject(this.uiContainer = new Object3D());
        this.uiContainer.name = 'uiContainer';
        this.uiContainer.visible = false;
        // this.uiContainer.position.z = -5;
        this.addObject(this.uiContainerObjects = new Object3D());
        this.uiContainerObjects.name = 'uiContainerObjects';
        this.uiContainerObjects.visible = false;
        // this.uiContainerObjects.position.z = -5;
        this.tasksProgress = new TasksProgress();
        this.tasksProgress.uiObject.position.set(0, 4.3, -5);
        this.tasksProgress.uiObject.userData.pcPosition = this.tasksProgress.uiObject.position.clone();
        this.tasksProgress.uiObject.name = 'Task PROGRESS';
        this.uiContainer.add(this.tasksProgress.uiObject);
        this.taskScreen = new TaskScreen();
        this.taskScreen.uiObject.position.set(0, 1, -5);
        this.taskScreen.uiObject.userData.pcPosition = this.taskScreen.uiObject.position.clone();
        this.taskScreen.uiObject.name = 'Task SCREEN';
        this.uiContainer.add(this.taskScreen.uiObject);
        this.welcomeScreen = new WelcomeScreen();
        this.welcomeScreen.uiObject.position.set(0, .5, 1);
        this.welcomeScreen.uiObject.userData.pcPosition = this.welcomeScreen.uiObject.position.clone();
        this.welcomeScreen.uiObject.name = 'ERROR_POP_UP';
        this.welcomeScreen.uiObject.visible = false;
        this.uiContainer.add(this.welcomeScreen.uiObject);
        this.welcomeScreen.init('Experiment finished!', 'You have successfully accomplished the experiment.', 'Back to Lobby');
        this.welcomeScreen.on('ok', () => {
            this.interaction = false;
            // @ts-ignore
            if (!this.welcomeScreen.secondButton.uiObject.parent)
                this.levelFinished = true;
            if (this.levelFinished) {
                if (this.taskScreen && this.tasksProgress) {
                    this.removeObject(this.taskScreen);
                    this.removeObject(this.tasksProgress);
                }
                this.title.setProgress('8/8');
            }
            this.fire('exit', new ParentEvent('exit'));
        });
        this.welcomeScreen.on('secondButtonClick', () => {
            this.welcomeScreen.uiObject.visible = false;
            this.restart();
            this.interaction = true;
        });
        this.instruments.pipette.once('not_full', (event) => {
            this.welcomeScreen.init('Experiment failed!', 'Looks like you got wrong amount of liquid', 'Back to Lobby', 'Try Again!');
        });
    }
    addLobbyUI(levelNumber, title) {
        let lobbyUI = new Object3D();
        lobbyUI.name = 'LOBBY UI';
        this.addObject(lobbyUI);
        this.title = new LobbyScreen();
        this.title.init('Level ' + levelNumber, title, '0/8');
        lobbyUI.add(this.title.uiObject);
        this.title.uiObject.position.y = 10;
        this.title.on('start', () => {
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.fire('start', new ParentEvent('start'));
        });
        this.on('started', () => {
            this.interaction = true;
        });
        this.title.on('tutorial', () => {
            this.fire('tutorial');
        });
    }
    initScenario() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        MaterialImprovement.upgradeMaterialsFromModel(this.table, this.uiObject.name);
        this.scenario = {
            name: 'scenarioName',
            modules: [
                { name: 'tasksProgress', instance: this.tasksProgress },
                { name: 'taskScreen', instance: this.taskScreen },
                { name: 'welcomeScreen', instance: this.welcomeScreen },
                { name: 'lobbyScreen', instance: this.title },
                { name: 'pipetteHolder', instance: this.instruments.pipetteHolder },
                { name: 'pipette', instance: this.instruments.pipette },
                { name: 'testTubeHolder', instance: this.instruments.testTubeHolder },
                { name: 'jar', instance: this.instruments.jar },
            ],
            steps: [
                {
                    onBefore: [
                        ['tasksProgress', 'init', 8, 0],
                        ['jar', 'init'],
                        ['testTubeHolder', 'init'],
                        ['pipette', 'init'],
                        ['pipetteHolder', 'createClickEvent'],
                        ['pipetteHolder', 'returnToHolder'],
                        [
                            'taskScreen', 'init', 'Task 1',
                            'Pick up Serological Pipette.',
                            `${((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled) ? 'Press and hold' : 'Click on'} the serological pipette hanging on the stand to pick it up.`,
                            1.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipetteHolder.once('holder_clicked', resolve);
                    }),
                    onAfter: [
                        ['pipette', 'addToPointer'],
                        ['jar', 'createClickEvent'],
                        ['tasksProgress', 'init', 8, 1],
                        ['lobbyScreen', 'setProgress', '1/8'],
                    ]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 2',
                            'Fill up pipette with 5 ml of liquid.',
                            ((_b = Viewer.zSpace) === null || _b === void 0 ? void 0 : _b.enabled)
                                ? ('Release the serological pipette on the bowl with red liquid. ' +
                                    'Next, press the Left button on stylus to fill up the serological pipette with liquid. ' +
                                    'Hold the Left button until it reaches the red line. Finally, once you have the correct amount of liquid click the blue check button.')
                                : ('First, click on the bowl with red liquid to place the pipette. ' +
                                    'Next, click on the top button of the serological pipette to fill liquid. ' +
                                    'Hold the button down until it reaches the red line. Finally, once you have the correct amount of liquid click the blue check button.'),
                            0.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.jar.once('holder_clicked', resolve);
                    }),
                    onAfter: [['pipette', 'initFilling']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('ready_to_fill', resolve);
                    }),
                    onAfter: [['pipette', 'startFilling', 5]]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('pipette_full', resolve);
                    }),
                    onAfter: [
                        ['pipette', 'addToPointer'],
                        ['testTubeHolder', 'createClickEvent'],
                        ['tasksProgress', 'init', 8, 2],
                        ['lobbyScreen', 'setProgress', '2/8']
                    ]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 3',
                            'Transfer 5ml liquid to test tube.',
                            ((_c = Viewer.zSpace) === null || _c === void 0 ? void 0 : _c.enabled)
                                ? ('Select the serological pipette, and release over the test tube to place the pipette. \n ' +
                                    'Next, press the Right button on stylus until all of the liquid is dispensed into the test tube. \n ' +
                                    'Finally, click the blue check button once you are have successfully transferred the liquid.')
                                : ('First, click on the test tube to place the pipette. \n ' +
                                    'Next, press the bottom button and hold it down until all of the liquid is dispensed into the test tube. \n ' +
                                    'Finally, click the blue check button once you are have successfully transferred the liquid.'),
                            0.15
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.testTubeHolder.once('holder_clicked', resolve);
                    }),
                    onAfter: [['pipette', 'initDevastation', 1]]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('ready_to_devastate', resolve);
                    }),
                    onAfter: [['pipette', 'startDevastation']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('pipette_empty', (event) => {
                            this.instruments.testTubeHolder.setLeftTube(event.data.waterLevel);
                            resolve();
                        });
                    }),
                    onAfter: []
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('pipette_empty_button', resolve);
                    }),
                    onAfter: [
                        ['pipette', 'updateModel', 'serological_pipette_3'],
                        ['jar', 'createClickEvent'],
                        ['tasksProgress', 'init', 8, 3],
                        ['lobbyScreen', 'setProgress', '3/8']
                    ]
                },
                // 3 ================================================
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 4',
                            'Fill up pipette with 3 ml of liquid.',
                            ((_d = Viewer.zSpace) === null || _d === void 0 ? void 0 : _d.enabled)
                                ? ('Press and hold the serological pipette. Release the serological pipette on the bowl with red liquid. ' +
                                    'Next, press the Left button on the stylus to fill up the serological pipette with liquid. Hold the Left button until it reaches the red line. ' +
                                    'Finally, once you have the correct amount of liquid click the blue check button.')
                                : ('First, click on the bowl of red liquid to place the pipette. ' +
                                    'Next, click on the top button of the serological pipette to fill liquid. ' +
                                    'Hold the button down until it reaches the red line. ' +
                                    'Finally, once you have the correct amount of liquid click the blue check button.'),
                            0.25
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.jar.once('holder_clicked', resolve);
                    }),
                    onAfter: [['pipette', 'initFilling']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('ready_to_fill', resolve);
                    }),
                    onAfter: [['pipette', 'startFilling', 3]]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('pipette_full', resolve);
                    }),
                    onAfter: [
                        ['testTubeHolder', 'createClickEvent'],
                        ['pipette', 'addToPointer'],
                        ['lobbyScreen', 'setProgress', '4/8'],
                        ['tasksProgress', 'init', 8, 4]
                    ]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 5',
                            'Transfer 3ml liquid to test tube.',
                            ((_e = Viewer.zSpace) === null || _e === void 0 ? void 0 : _e.enabled)
                                ? ('Select the serological pipette, and release over the test tube to place the pipette. \n ' +
                                    'Next, press the Right button on stylus until all of the liquid is dispensed into the test tube. \n ' +
                                    'Finally, click the blue check button once you are have successfully transferred the liquid.')
                                : ('First, click on the test tube to place the pipette. \n ' +
                                    'Next, press the bottom button and hold it down until all of the liquid is dispensed into the test tube. \n ' +
                                    'Finally, click the blue check button once you are have successfully transferred the liquid.'),
                            0.05
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.testTubeHolder.once('holder_clicked', resolve);
                    }),
                    onAfter: [['pipette', 'initDevastation', 2]]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('ready_to_devastate', resolve);
                    }),
                    onAfter: [['pipette', 'startDevastation']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('pipette_empty', (event) => {
                            this.instruments.testTubeHolder.setCenterTube(event.data.waterLevel);
                            resolve();
                        });
                    }),
                    onAfter: []
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('pipette_empty_button', resolve);
                    }),
                    onAfter: [
                        ['pipette', 'updateModel', 'serological_pipette_8'],
                        ['tasksProgress', 'init', 8, 5],
                        ['lobbyScreen', 'setProgress', '5/8'],
                        ['jar', 'createClickEvent'],
                    ]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 6',
                            'Fill up pipette with 8ml of liquid.',
                            ((_f = Viewer.zSpace) === null || _f === void 0 ? void 0 : _f.enabled)
                                ? ('Press and hold the serological pipette. ' +
                                    'Release the serological pipette on the bowl with red liquid. ' +
                                    'Next, press the Left button on stylus to fill up the serological pipette with liquid. ' +
                                    'Hold the Left button until it reaches the red line. Finally, once you have the correct amount of liquid click the blue check button.')
                                : ('First, click on the bowl of red liquid to place the pipette. ' +
                                    'Next, click on the top button of the serological pipette to fill liquid. ' +
                                    'Hold the button down until it reaches the red line. ' +
                                    'Finally, once you have the correct amount of liquid click the blue check button.'),
                            0.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.jar.once('holder_clicked', resolve);
                    }),
                    onAfter: [['pipette', 'initFilling']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('ready_to_fill', resolve);
                    }),
                    onAfter: [['pipette', 'startFilling', 8]]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.pipette.once('pipette_full', resolve);
                    }),
                    onAfter: [
                        ['testTubeHolder', 'createClickEvent'],
                        ['pipette', 'addToPointer'],
                        ['tasksProgress', 'init', 8, 6],
                        ['lobbyScreen', 'setProgress', '6/8']
                    ]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 7',
                            'Transfer 8ml liquid to test tube.',
                            ((_g = Viewer.zSpace) === null || _g === void 0 ? void 0 : _g.enabled)
                                ? ('Select the serological pipette, and release over the test tube to place the pipette. \n ' +
                                    'Next, press the Right button on stylus until all of the liquid is dispensed into the test tube. \n ' +
                                    'Finally, click the blue check button once you are have successfully transferred the liquid.')
                                : ('First, click on the test tube to place the pipette. \n ' +
                                    'Next, press the bottom button and hold it down until all of the liquid is dispensed into the test tube. \n ' +
                                    'Finally, click the blue check button once you are have successfully transferred the liquid.'),
                            0.14
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.instruments.testTubeHolder.once('holder_clicked', resolve);
                    }),
                    onAfter: [['pipette', 'initDevastation', 3]]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('ready_to_devastate', resolve);
                    }),
                    onAfter: [['pipette', 'startDevastation']]
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('pipette_empty', (event) => {
                            this.instruments.testTubeHolder.setRightTube(event.data.waterLevel);
                            resolve();
                        });
                    }),
                    onAfter: []
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipette.once('pipette_empty_button', resolve);
                    }),
                    onAfter: [
                        ['pipette', 'addToPointer'],
                        ['pipetteHolder', 'createClickEvent', true],
                        ['lobbyScreen', 'setProgress', '7/8'],
                        ['tasksProgress', 'init', 8, 7]
                    ]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 8',
                            'Put the Pipette back.',
                            `${((_h = Viewer.zSpace) === null || _h === void 0 ? void 0 : _h.enabled) ? 'Drag the serological pipette to' : 'Click on'} the pipette stand to hang up the pipette.`,
                            1.2
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.lobby.showMenu(false);
                        this.instruments.pipetteHolder.once('holder_clicked', () => {
                            this.interaction = false;
                            resolve();
                        });
                    }),
                    onAfter: [
                        ['pipette', 'addToHolder'],
                        ['tasksProgress', 'init', 8, 8],
                        ['lobbyScreen', 'setProgress', '8/8'],
                        ['welcomeScreen', 'show', 'true'],
                    ]
                },
            ]
        };
        const scenarioProcessor = new ScenarioProcessor(this.scenario);
        scenarioProcessor.init();
    }
    showInfo(isShow = true) {
        this.title.uiObject.visible = isShow;
        this.uiContainerObjects.visible = this.uiContainer.visible = !isShow;
    }
    hideAllInfo() {
        this.uiContainerObjects.visible = this.uiContainer.visible = this.title.uiObject.visible = false;
    }
    restart() {
        this.title.setProgress('0/8');
        this.pointerController.setObject(null);
        this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject && this.lobby.app.zSpacePickingController.forceRelease();
        this.table.traverse(el => {
            if (this.lobby.app.zSpacePickingController)
                this.lobby.app.zSpacePickingController.off(null, el);
        });
        for (let instrumentsKey in this.instruments) {
            this.disposeObject(this.instruments[instrumentsKey]);
        }
        this.interaction = false;
        this.welcomeScreen.init('Experiment finished!', 'You have successfully accomplished the experiment.', 'Back to Lobby');
        this.welcomeScreen.uiObject.visible = false;
        this.initInstruments();
        this.initScenario();
        this.instruments.pipette.once('not_full', (event) => {
            this.welcomeScreen.init('Experiment failed!', 'Looks like you got wrong amount of liquid', 'Back to Lobby', 'Try Again!');
            this.levelFinished = false;
        });
    }
    update() {
    }
}
